import api from './api';

class PromocodeService {
  getListPromocode(dataForm) {
    return api.post('/get-promo-code', dataForm);
  }
  
  // The member's OWN vouchers (MyVouchers.vue): type 1 = still usable,
  // type 2 = used or expired. with_bundle=1 folds owned voucher bundles into
  // the same list, flagged is_bundle. Distinct from getMyRewardOrderingOnline
  // below, which only returns what can be applied to the cart in hand.
  getMyRewards(dataForm) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/rewards/my-reward`, dataForm);
  }

  getMyReward(dataForm) {
    // return api.get("/member/rewards/my-reward", {
    //   baseURL: process.env.VUE_APP_BASE_MINTY_URL,
    //   headers: {
    //       'Merchantid': dataForm.merchant_id
    //   },
    //   params: {
    //     type: dataForm.type,
    //     search_keyword: dataForm.search_keyword,
    //     memberId: dataForm.memberId,
    //   }
    // });
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/rewards/my-reward`, dataForm);
  }

  calculateVoucherPrice(dataForm) {
    return api.post('/calculate-voucher-price', dataForm);
  }

  getListVoucher(dataForm) {
    return api.post('/get-free-vouchers', dataForm);
  }

  exchangeFreeVoucher(dataForm) {
    return api.post('/exchange-free-voucher', dataForm);
  }

  getMyRewardOrderingOnline(dataForm) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/rewards/my-reward-for-ordering-online`, dataForm);
  }

  getRewardCatalogue(dataForm) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/rewards`, dataForm);
  }

  // Voucher bundles — the member site keeps these on a separate "Store" screen,
  // MOO lists them next to single vouchers. Same payload shape: the BE
  // normalises bundles onto reward_title / point_text / amount_text /
  // is_disabled / expiry_date_text.
  getVoucherBundles(dataForm) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/vouchers-bundle`, dataForm);
  }

  // Two modes of one endpoint:
  //   is_reward = 0 → the store view: what the bundle contains and what it costs.
  //   is_reward = 1 (+ member_voucher_bundle_id) → an owned bundle: the same
  //     header plus voucher_in_bundle_unused / voucher_in_bundle_used, the
  //     individual vouchers issued to this member.
  getVoucherBundleDetail(dataForm) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/voucher-bundle/detail`, dataForm);
  }

  exchangeVoucherBundle(dataForm) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/voucher-bundle/exchange`, dataForm);
  }

  getRewardDetail(rewardId, isMyReward = 0, campaignId = 0) {
    return api.get(`${process.env.VUE_APP_BASE_MINTY_URL}/member/rewards/detail/${rewardId}/${isMyReward}/${campaignId}`);
  }

  exchangeReward(dataForm) {
    return api.post(`${process.env.VUE_APP_BASE_MINTY_URL}/member/rewards/exchange`, dataForm);
  }

  getListFreeItem(dataForm) {
    return api.post('/get-free-items', dataForm);
  }
}

export default new PromocodeService();
